import { SegmentInfluencer } from '../../../../models/measure/report';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../services/user.service';
var InfluencerOverviewReportComponent = /** @class */ (function () {
    function InfluencerOverviewReportComponent(pdfService, userService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.nationalityChartSeriesColors = [];
        // use for nationality circle chart
        this.nationalityCircleChartData = [];
        // use for nationality circle chart
        this.platformLineChartData = [];
    }
    InfluencerOverviewReportComponent.prototype.ngOnInit = function () {
        if (this.segmentInfluencerOverview) {
            // reverse the first color to make nationality first color different with platform chart
            var seriesColors = this.userService.chartColors.slice(); // clone array
            var firstColor = seriesColors.shift();
            seriesColors.push(firstColor);
            this.nationalityChartSeriesColors = seriesColors;
            this.nationalityCircleChartData = this.segmentInfluencerOverview.nationalities ?
                this.segmentInfluencerOverview.nationalities.map(function (nation) { return ({
                    name: nation.name,
                    y: nation.percent
                }); }) : [];
            this.platformLineChartData = this.segmentInfluencerOverview.platforms.map(function (platform) { return ({
                name: platform.name,
                y: platform.value
            }); });
        }
    };
    InfluencerOverviewReportComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(InfluencerOverviewReportComponent.COMPONENT_NAME);
    };
    Object.defineProperty(InfluencerOverviewReportComponent.prototype, "haveNoData", {
        get: function () {
            if (!this.segmentInfluencerOverview) {
                return true;
            }
            return this.segmentInfluencerOverview.influencers.value === 0
                && (!this.segmentInfluencerOverview.nationalities || this.segmentInfluencerOverview.nationalities.length === 0)
                && this.segmentInfluencerOverview.platforms.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerOverviewReportComponent.prototype.getPieCenter = function () {
        return this.pieChartCenter = this.pieChartCenter ? this.pieChartCenter : InfluencerOverviewReportComponent.DEFAULT_PIE_CENTER;
    };
    InfluencerOverviewReportComponent.COMPONENT_NAME = 'InfluencerOverviewReportComponent';
    InfluencerOverviewReportComponent.DEFAULT_PIE_CENTER = [103, 45];
    return InfluencerOverviewReportComponent;
}());
export { InfluencerOverviewReportComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/influencer-overview-report/influencer-overview-report.component.ts.pre-build-optimizer.js